import React, { useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Footer from "../utilities/Footer";
import AppState from "../../util/AppState";
import config from "../../customStylesAndConfigs/config.json";
import { v4 as uuid_v4 } from "uuid";
import { logFunctions as log } from "../../util/Logging";
import calculateHMACToken from "../../util/calculateHMACToken";
import ImageCarousel from "../utilities/ImageCarousel";

function AttractScreen(props) {
  log.debug("+AttractScreen(TRACE)");

  const { t } = useTranslation("translation");
  let timer = null;
  let payloadToServer = {
    cardNumber: "",
    userType: "",
    wallID: "",
  };

  useEffect(() => {
    log.debug("+AttractScreen_useEffect(TRACE)");
    if (
      localStorage.getItem("expirationTimeOfConfigs") <= new Date().getTime() ||
      !localStorage.getItem("attendantCardMasks") ||
      !localStorage.getItem("customerCardMasks") ||
      !localStorage.getItem("managerCardMasks")
    ) {
      log.info("AttractScreen_useEffect() => Getting card masks");
      const date = new Date();
      const dateForAuth = date.toISOString().slice(0, 19) + ".000Z";
      const correlation_id = uuid_v4();
      const secretKey = window.atob(localStorage.getItem("SecretKey"));

      const hmacToken = calculateHMACToken(
        secretKey,
        localStorage.getItem("SharedKey"),
        localStorage.getItem("orgID"),
        dateForAuth,
        "GET",
        window.APIGEEPATH + "/storeConfig",
        correlation_id
      );

      axios({
        method: "get",
        url: window.SCANNERWALLPROXYURL + "/storeConfig",
        headers: {
          "nep-organization": localStorage.getItem("orgID"),
          "nep-enterprise-unit": localStorage.getItem("siteID"),
          "nep-correlation-id": correlation_id,
          "Date-Header": date.toGMTString(),
          Authorization: hmacToken,
        },
      })
        .then((response) => {
          log.info(
            "AttractScreen_useEffect() => Nep correlation Id: " +
              correlation_id +
              ". The response for store config is: " +
              JSON.stringify(response.data)
          );
          if (response.status === 200) {
            localStorage.setItem(
              "customerCardMasks",
              JSON.stringify(response.data.loyaltyCardMasks)
            );
            localStorage.setItem(
              "attendantCardMasks",
              JSON.stringify(response.data.attendeeCardMasks)
            );
            localStorage.setItem(
              "managerCardMasks",
              JSON.stringify(response.data.managerCardMasks)
            );
            localStorage.setItem(
              "expirationTimeOfConfigs",
              new Date().getTime() + response.data.expireAfterMinutes * 60000
            );
            log.info(
              "AttractScreen_useEffect() => The card masks are set in local storage."
            );
          }
        })
        .catch((response) => {
          log.info(
            "AttractScreen_useEffect() => Unable to set card masks in local storage." +
              response
          );
        });
    }
    log.debug("-AttractScreen_useEffect(TRACE)");
    return () => {
      clearTimeout(timer);
    };
  });

  const handleChange = (e) => {
    const scanInput = e.target.value;
    clearTimeout(timer);
    const customerCardMasks = JSON.parse(
      localStorage.getItem("customerCardMasks")
    );
    timer = setTimeout(() => {
      scanInput.length > customerCardMasks[0].length
        ? props.processScan(scanInput.substring(0, customerCardMasks[0].length))
        : props.processScan(scanInput);
    }, 100);
  };

  const TextBox = () => {
    log.debug("+AttractScreen_TextBox(TRACE)");
    if (config.welcomeScreenHasVideoPlayback) {
      log.info("AttractScreen_TextBox() => Video playback in welcome screen");
      log.debug("-AttractScreen_TextBox(TRACE)");
      return (
        <div className="reconfiguredTextBox" id="welcomeContentLabel">
          <h4 className="videoPlaybackh4">{t("Speed up your shopping!")} </h4>
          <p className="videoPlaybackp">
            {t("Use our mobile shopper app to scan as you go!")}
          </p>
        </div>
      );
    } else {
      log.info(
        "AttractScreen_TextBox() => No video playback in welcome screen"
      );
      log.debug("-AttractScreen_TextBox(TRACE)");
      return (
        <div className="defaultTextBox" id="welcomeContentLabel">
          <h4 className="defaulth4">{t("Speed up your shopping!")} </h4>
          <p className="defaultp">
            {t("Use our mobile shopper app to scan as you go!")}
          </p>
        </div>
      );
    }
  };

  const videoPlayBack = () => {
    log.debug("+AttractScreen_videoPlayback(TRACE)");
    log.debug("-AttractScreen_videoPlayback(TRACE)");
    return (
      <video className="videoTag" autoPlay loop muted>
        <source src={config.videoBackgroundUrl} type="video/mp4" />
      </video>
    );
  };

  log.debug("-AttractScreen(TRACE)");
  return (
    <div className="welcomeScreen">
      {!config.welcomeScreenHasVideoPlayback ? null : videoPlayBack()}
      <div className="logoContainer">
        <div id="logo">
          <div id="logo-img" />
        </div>
      </div>

      <div
        className={
          !config.welcomeScreenHasVideoPlayback
            ? "mediaContainer"
            : "mediaContainerVideoPlayback"
        }
        id="mediaContainerLabel"
      >
        <ImageCarousel />
        <div className="mediaContent" id="mediaContentLabel">
          {TextBox()}
          <div
            className="getScannerButton"
            id="getScannerButtonLabel"
            onClick={async () => {
              await props.transitionToUnlockingScreen();
              payloadToServer = {
                cardNumber: "A-" + uuid_v4(),
                userType: "anonymous",
                wallID: localStorage.getItem("wallID"),
              };
              await props.unlockWithCredentials(payloadToServer);
            }}
          >
            <p>{t("Get your scanner")}</p>
          </div>
        </div>
      </div>

      <div className="buttonContainer">
        <div className="scanButton" id="scanButtonLabel">
          <div id="scanIcon"></div>
          <p>{t("Loyalty customer? Scan your loyalty ID below")}</p>
        </div>

        <div
          className="keyInButton"
          id="keyInButtonLabel"
          onClick={props.transitionToEnterLoyaltyCardScreen}
        >
          <div id="keyboardIcon"></div>
          <p>{t("Key in loyalty ID")}</p>
        </div>
      </div>
      <input
        style={{ position: "absolute", top: -100 }}
        id="scanInput"
        type="text"
        autoFocus
        onBlur={({ target }) => target.focus()}
        onChange={(e) => handleChange(e)}
      />
      <div className="attractFooterContainer" id="footer">
        <Footer
          transitionToSelectLanguageScreen={
            props.transitionToSelectLanguageScreen
          }
          state={AppState.ATTRACT_SCREEN}
        />
      </div>
    </div>
  );
}

export default AttractScreen;
